module.exports = __webpack_public_path__ + "img/Chelora.7482efbd.jpg";